import { selectIsLoggedIn } from '@/features/oAuth/oAuthSlice';
import { useGetUserQuery } from '@/features/user/userApi';
import Icon from '@/shared/components/Icon/Icon';
import LoginButton from '@/shared/components/LoginButton/LoginButton';
import MenuItem from '@/shared/components/MenuItem/MenuItem';
import { menuItems } from '@/shared/config/menuItems';
import { IonButtons, IonCol, IonGrid, IonHeader, IonLabel, IonRouterLink, IonRow, IonToolbar } from '@ionic/react';
import { useSelector } from 'react-redux';
import UserProfileMenu from '../UserProfileMenu/UserProfileMenu';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import styles from './DesktopHeader.module.css';
import { t } from 'i18next';

type Props = {
  showNotificationForTravelRule?: boolean;
  notificationCount: number;
};

const NavBar: React.FC<Props> = ({ showNotificationForTravelRule, notificationCount }) => {
  return (
    <>
      <IonCol size="9">
        <IonGrid>
          <IonRow className="ion-justify-content-center">
            {menuItems.map((item, index) => {
              return (
                <MenuItem
                  index={index}
                  item={item}
                  key={item.title}
                  showNotificationForTravelRule={!!(item.title === 'menu.wallets' && showNotificationForTravelRule)}
                  notificationCount={notificationCount}
                />
              );
            })}
          </IonRow>
        </IonGrid>
      </IonCol>
      <IonCol size="1">
        <IonToolbar className={styles.menu}>
          <IonButtons slot="end">
            <LanguageSelector />
            <UserProfileMenu />
          </IonButtons>
        </IonToolbar>
      </IonCol>
    </>
  );
};

const Login: React.FC = () => {
  return (
    <IonCol size="10" className={styles.loginWrapper}>
      <IonToolbar>
        <IonButtons className={styles.loginMenu}>
          <LanguageSelector />
        </IonButtons>
        <LoginButton slot="end" className={`${styles.loginButton}`} />
      </IonToolbar>
    </IonCol>
  );
};

const DesktopHeader: React.FC<Props> = ({ showNotificationForTravelRule, notificationCount }) => {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const { data: userData, isLoading } = useGetUserQuery(undefined, {
    skip: !isLoggedIn
  });

  return (
    <IonHeader slot="fixed" className={styles.header}>
      <IonGrid className={styles.content}>
        <IonRow class="ion-align-items-center">
          <IonCol className={styles.logo} size="2">
            <IonLabel>
              <IonRouterLink color="primary" href="/">
                <Icon size="xxxxlLarge" src="assets/icons/bs-digital-logo.svg" className={styles.icon} />
              </IonRouterLink>
            </IonLabel>
          </IonCol>
          {!isLoading && userData && (
            <NavBar
              showNotificationForTravelRule={showNotificationForTravelRule}
              notificationCount={notificationCount}
            />
          )}
          {!isLoading && !userData && <Login />}
        </IonRow>
      </IonGrid>
    </IonHeader>
  );
};

export default DesktopHeader;
